import { SITUACAO_IMPEDIMENTOS_PROCESSO } from './SituacaoImpedimentosProcesso';

/**
 * @classdesc Agrega as regras semânticas relacionadas às situações de impedimentos no processo.
 * @readonly
 */
class SituacaoImpedimentosProcessoBusiness {
    totalizadorSituacoesNegocio;
    registro;

    constructor(registro) {
        this.totalizadorSituacoesNegocio = new Map();
        this.resetContabilizadores();
        this.registro = registro;
    }

    resetContabilizadores() {
        Object.keys(SITUACAO_IMPEDIMENTOS_PROCESSO).forEach((key) => {
            this.totalizadorSituacoesNegocio.set(key, 0);
        });
    }

    getSituacoes() {
        this.contabilizarSituacoes();
        let situacoes = [];

        for (const [key, value] of this.totalizadorSituacoesNegocio) {
            if (value > 0) {
                situacoes.push(key);
            }
        }

        return situacoes;
    }

    isImpedimentoComposicao(siglaImpedimento) {
        return (
            this.registro.composicao.findIndex(
                (composicao) =>
                    composicao.magistrado?.sigla === siglaImpedimento ||
                    composicao.magistrado?.siglaSubstituto === siglaImpedimento
            ) !== -1
        );
    }

    contabilizarSituacoes() {
        if (this.registro.impedimentos && this.registro.impedimentos.length > 0) {
            this.registro.impedimentos.forEach((impedimento) => {
                if (impedimento.magistrado?.sigla && impedimento.situacaoImpedimento) {
                    const estaNaComposicao = this.isImpedimentoComposicao(impedimento.magistrado.sigla);
                    let id = '';

                    if (impedimento.situacaoImpedimento === 'IMPEDIMENTO_DECLARADO') {
                        id = estaNaComposicao
                            ? SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_NA_COMPOSICAO.id
                            : SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_FORA_DA_COMPOSICAO.id;
                    } else {
                        id = estaNaComposicao
                            ? SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_NA_COMPOSICAO.id
                            : SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_FORA_DA_COMPOSICAO.id;
                    }

                    this.totalizadorSituacoesNegocio.set(id, this.totalizadorSituacoesNegocio.get(id) + 1 || 1);
                }
            });
        }
    }
}

export default SituacaoImpedimentosProcessoBusiness;
